import './Skill.scss'
import React,{useEffect,useState} from 'react'
import { motion } from "framer-motion";

import AppWrap from '../../wrapper/AppWrap';
import MotionWrap from '../../wrapper/MotionWrap';
import Mu from '../../assets/mu5.png'
import Redux from '../../assets/redux.png'
import Git from '../../assets/git.png'
import Socket from '../../assets/socket.jpg'
import prisma from '../../assets/prisma.png'
import express from '../../assets/express.png'
import  Tailwind from '../../assets/tailwind.jpg'
import solidity from '../../assets/solidity.png'

const skillSet=[
    {name:"Material UI",icon:Mu},
    {name:"Redux",icon:Redux},
    {name:"Git",icon:Git},
    {name:"Socket.io",icon:Socket},
    {name:"Prisma",icon:prisma},
    {name:"Express Js",icon:express},
    {name:"Tailwind Css",icon:Tailwind},
    {name:"Solidity",icon:solidity}
]

const experienceSet=[
    {year:"2023" ,name:"MLH HACKATHON 2ND RUNNERUP",company:"Diversion 2k23 organised by MLH+IEM KOLKATA"},
    {year:"2023" ,name:"MLH HACKATHON 2ND RUNNERUP",company:"STATUSCODE 0 organised by MLH+IIIT KALYANI"},
    {year:"2023" ,name:"POSTMAN TRACK WINNER",company:"STATUSCODE 0 organised by MLH+IIIT KALYANI"}, 
    {year:"2023" ,name:"SIH SEMI-FINALIST",company:"SIH HACKATHON"}, 
    {year:"2023" ,name:"FREELANCER",company:"Got My first project as backend developer"},   
]
function Skills() {
    const [skills,setSkills]=useState(skillSet)
    const [acheivement,setAcheivement]=useState(experienceSet)
  return (
    <div>
        <h2 className="head-text">Skills & Acheivement</h2>

        <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={skill.icon} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-exp">
          {acheivement.map((experience) => (
            <motion.div className="app__skills-exp-item" key={experience.year}>
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
            
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      data-tip
                      data-for={experience.name}
                      key={experience.name}
                    >
                      <h4 className="bold-text">{experience.name}</h4>
                      <p className="p-text">{experience.company}</p>
                    </motion.div>
                    
                  </>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AppWrap(
    MotionWrap(Skills, "app__skills"),
    "skills",
    "app__whitebg"
  );
  
